// extracted by mini-css-extract-plugin
export default {"custom__info":"icons_custom__info__jtEkV"};